import React from 'react';
import { IconsPros } from './types';

/**
 * Js Icon component
 *
 * @returns JSX.ELEMENT
 */
export const JsIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M6.08,4.37a5.46,5.46,0,0,0,.65.33,1.71,1.71,0,0,1,.7.49,1.08,1.08,0,0,1,.2.66,1.11,1.11,0,0,1-.19.65,1.12,1.12,0,0,1-.54.43,1.92,1.92,0,0,1-.82.16A3.14,3.14,0,0,1,5.42,7a2.22,2.22,0,0,1-.56-.2V5.9a3.14,3.14,0,0,0,.63.25,2.37,2.37,0,0,0,.6.09.62.62,0,0,0,.35-.08A.27.27,0,0,0,6.56,6a.18.18,0,0,0,0-.14.34.34,0,0,0-.13-.14c-.07,0-.25-.13-.53-.25a2.67,2.67,0,0,1-.58-.34A1.15,1.15,0,0,1,5,4.72a1.26,1.26,0,0,1-.09-.5,1,1,0,0,1,.4-.84,1.73,1.73,0,0,1,1.09-.3,3.12,3.12,0,0,1,1.25.28l-.33.81a2.39,2.39,0,0,0-1-.26A.53.53,0,0,0,6,4a.23.23,0,0,0-.1.18A.3.3,0,0,0,6.08,4.37ZM4.19,6.66a1.85,1.85,0,0,1-.35,1.21,1.34,1.34,0,0,1-1.05.4,2.53,2.53,0,0,1-.56-.06V7.4l.19,0,.21,0A.41.41,0,0,0,3,7.3a.94.94,0,0,0,.11-.54V3.13H4.19ZM14,0H2C.67,0,0,.41,0,1.73V14.27C0,15.59.67,16,2,16H14c1.32,0,2-.41,2-1.73V1.73C16,.41,15.32,0,14,0Z" />
    </svg>
  );
};
